import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
} from '@facet-wealth/design';
import TimelineYearGroup from 'Components/ComponentLibrary/Organisms/Timeline/TimelineYearGroup';
import fr from 'facet-rest';

export default function Timeline({ timelineYearGroupCollection, timelineCardComponent }) {
  const timelineYearGroupResources = timelineYearGroupCollection.resources().list();
  const timelineYearGroupResourcesLength = timelineYearGroupCollection.resources().length();

  return (
    <FDBox>
      {timelineYearGroupResources.map((yearGroup, yearGroupIdx) => {
        return <TimelineYearGroup yearGroupResource={yearGroup} timelineCardComponent={timelineCardComponent} isFirstItem={yearGroupIdx === 0} isLastItem={yearGroupIdx === timelineYearGroupResourcesLength - 1} key={yearGroup.attr('year')} />;
      })}
    </FDBox>
  );
}

Timeline.defaultProps = {
};

Timeline.propTypes = {
  timelineYearGroupCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  timelineCardComponent: PropTypes.element.isRequired,
};
